import MainLayout from "@/components/layout/admin/MainLayout.vue";
import VueSlickCarousel from 'vue-slick-carousel';
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";

export default {
  name: "HomeIndex",
  components: {
    MainLayout,
    VueSlickCarousel,
    Loading,
    CONFIG
  },

  data() {
    return {
      setting: {
        "slidesToShow": 4,
        "slidesToScroll": 1,
        "arrows": false,
        "dots": true,
        "speed": 300,
        "infinite": true,
        "autoplaySpeed": 3000,
        "autoplay": true,
        "responsive": [{
            "breakpoint": 991,
            "settings": {
              "slidesToShow": 3,
            }
          },
          {
            "breakpoint": 767,
            "settings": {
              "slidesToShow": 1,
            }
          }
        ]
      },

      settingStaff: {
        "slidesToShow": 5,
        "slidesToScroll": 1,
        "arrows": false,
        "dots": true,
        "speed": 300,
        "infinite": true,
        "autoplaySpeed": 3000,
        "autoplay": true,
        "responsive": [{
            "breakpoint": 991,
            "settings": {
              "slidesToShow": 3,
            }
          },
          {
            "breakpoint": 767,
            "settings": {
              "slidesToShow": 1,
            }
          }
        ]
      },
      gradeArr: [],
      selectedGrade: 0,
      employeeList: {},
      studentList: {},
      payment: 0,
      income: 0,
      outcome: 0,
      balance: 0,
      slideCount: 0,
      noticeCount: 0,
      totalTeacherCount: 0,
      totalEmployeeCount: 0,
      totalDriverCount: 0,
      totalFerryCount: 0,
      activeStudentCount: 0,
      leavedStudentCount: 0,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      isLoading: false,
      hasClass: false,
      isStaff: true,
      isAccountant: false,
      CONFIG,
      role: CONFIG.ROLE.ID,
    }
  },

  computed: {
    isTeacher() {
      return this.auth('teacher').check();
    },

    isHr() {
      const user = this.$store.state.user;
      if (!user) return false;

      return user.role === this.role.HR_OPERATOR;
    },
  },

  methods: {
    getNoticecount () {
      axios.get("/notice/allNoticeCount", { params: { campus_id: this.$store.state.user.campus_id }})
        .then(response => {
          this.noticeCount = response.data;
        })
        .catch(error => {
          this.handleDashboardError(error, "Notice Count API Error");
        });
    },

    getPaymentData() {
      axios.get("/payment/totalPayment", { params: { campus_id: this.$store.state.user.campus_id }})
        .then((response) => {
          this.payment = response.data;
        })
        .catch((error) => {
          this.handleDashboardError(error, "Payment API Error");
        });
    },

    getTransactionInfo() {
      axios.get("/transaction/info", { params: { campus_id: this.$store.state.user.campus_id }})
        .then((response) => {
          this.income = response.data.income;
          this.outcome = response.data.outcome;
          this.balance = response.data.balance;
        })
        .catch((error) => {
          this.handleDashboardError(error, "Income Expense API Error");
        });
    },

    fetchLatestEmployeeList() {
      this.isLoading = true;
      axios.get("/employee/latestList", { params: { campus_id: this.$store.state.user.campus_id } })
        .then((response) => {
          this.employeeList = response.data;
          this.slideCount = response.data.length;
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.log('Employee List API Error', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getTotalTeacherCount() {
      axios.get("/teacher/getAllTeacherCount", { params: { campus_id: this.$store.state.user.campus_id }})
        .then((response) => {
          this.totalTeacherCount = response.data;
        })
        .catch((error) => {
          this.handleDashboardError(error, "Teacher Count API Error");
        });
    },

    getTotalStudentCount() {
      axios.get("/student/getAllStudentCount", { params: { campus_id: this.$store.state.user.campus_id }})
        .then((response) => {
          this.activeStudentCount = response.data.activeCount;
          this.leavedStudentCount = response.data.leavedCount;
        })
        .catch((error) => {
          this.handleDashboardError(error, "Student Count API Error");
        });
    },

    getLatestStudentList() {
      axios.get("/student/latestList", { params: { campus_id: this.$store.state.user.campus_id }})
        .then(response => {
          this.studentList = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          this.handleDashboardError(error, "Student List API Error");
        });
    },

    /**
     * Handle dashboard API errors without logging teachers out.
     *
     * @param {Object} error
     * @param {string} label
     */
    handleDashboardError(error, label) {
      if (error.response && error.response.status == 401 && !this.isTeacher) {
        this.$store.commit('logout');
        window.location.replace('login');
        return;
      }
      this.isLoading = false;
      console.log(label, error);
    },

    getTotalEmployeeCount() {
      axios.get("/employee/getAllEmployeeCount", { params: { campus_id: this.$store.state.user.campus_id }})
        .then((response) => {
          this.totalEmployeeCount = response.data;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
           this.$store.commit('logout');
           window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Employee Count API Error", error);
        });
    },

    getTotalDriverCount() {
      axios.get("/employee/getAllDriverCount", { params: { campus_id: this.$store.state.user.campus_id }})
        .then((response) => {
          this.totalDriverCount = response.data;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
           this.$store.commit('logout');
           window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Driver Count API Error", error);
        });
    },

    getTotalFerryCount() {
      axios.get("/employee/getAllFerryCount", { params: { campus_id: this.$store.state.user.campus_id }})
        .then((response) => {
          this.totalFerryCount = response.data;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
           this.$store.commit('logout');
           window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Ferry Count API Error", error);
        });
    },
  },
  
  mounted() {
    this.isLoading = true;
    this.getNoticecount();
    this.getPaymentData();
    this.getTransactionInfo();
    this.getTotalTeacherCount();
    this.getTotalStudentCount();
    this.getLatestStudentList();
    if (!this.isTeacher) {
      this.getPaymentData();
      this.getTransactionInfo();
    }
    if (this.isHr) {
      this.fetchLatestEmployeeList();
      this.getTotalEmployeeCount();
      this.getTotalDriverCount();
      this.getTotalFerryCount();
    }
    this.$store.state.user.role == CONFIG.ROLE.ID.STAFF ? this.isStaff = true : this.isStaff = false;
    this.$store.state.user.role == CONFIG.ROLE.ID.ACCOUNTANT ? this.isAccountant = true : this.isAccountant = false;
  },
};
